<div class="loading-overlay-content" [attr.inert]="visible ? '' : null">
  <ng-content></ng-content>
</div>
<div class="loading-overlay" *ngIf="visible" role="status" aria-live="polite">
  <div class="loading-indicator">
    <img src="assets/gif/loading.gif" alt="Loading" class="loading-gif">
    <span class="loading-text" *ngIf="message">{{ message }}</span>
  </div>
</div>
